import { useEffect, useState } from 'react';

/* `pointer: coarse` is true when the primary input is a finger or stylus.

   Deliberately not a width check: an iPad in landscape is 1024px wide — wider than
   plenty of laptops — so viewport width says nothing about whether a finger or a mouse
   is driving, and control sizing needs to follow the finger. Reactive because iPads
   report a fine pointer once a trackpad keyboard case is attached. */
const COARSE_POINTER = '(pointer: coarse)';

export const useIsTouch = (): boolean => {
  const [touch, setTouch] = useState(
    () => typeof window !== 'undefined' && window.matchMedia?.(COARSE_POINTER).matches === true,
  );

  useEffect(() => {
    const mq = window.matchMedia?.(COARSE_POINTER);
    if (!mq) return;
    const update = (e: MediaQueryListEvent) => setTouch(e.matches);
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);

  return touch;
};

export default useIsTouch;
